export default __webpack_public_path__ + "static/media/gal1.865c6e2a.jpeg";